// extracted by mini-css-extract-plugin
export var button = "_l2-2";
export var card = "_l2-0";
export var closeButtonContainer = "_l2-3";
export var iconContainer = "_l2-1";